import { url } from "../Common/common";

async function postFormData(path, data) {
  const formData = new FormData();
  Object.entries(data || {}).forEach(([k, v]) => formData.append(k, v));
  const res = await fetch(`${url}${path}`, { method: 'POST', body: formData });
  return res.json();
}

export function getWeeklyOrders(pars, callback) {
  postFormData('/getstatorders_by_weeks', {
    date_start: pars.date_start,
    date_end: pars.date_end,
    user_id: pars.user_id,
  })
    .then((data) => callback(data))
    .catch((err) => {
      console.log('getWeeklyOrders error', err);
      callback({ res: false, error: err });
    });
}


